import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import {
  MillwrightDaysSinceLastIncident,
  MillwrightLastFatigueWarning,
} from '@/apis/incidents/types/incidentsApi';
import { daysSinceLastIncidentFromApiAdapter } from '@/apis/incidents/adapters/daysSinceLastIncidfentFromApiAdapter';
import { daysSinceLastFatigueWarningFromApiAdapter } from '@/apis/incidents/adapters/daysSinceLastFatigueWarningFromApiAdapter';
import { prepareHeadersWithAuthorization as prepareHeaders } from '@/apis/headers';

const BASE_URL = import.meta.env.VITE_APP_API_URL;

export const incidentsApi = createApi({
  reducerPath: 'incidentsApi',
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL, prepareHeaders }),
  endpoints: (builder) => ({
    getMillwrightDaysSinceLastIncident: builder.query<
      MillwrightDaysSinceLastIncident,
      number
    >({
      query: (empId) => ({
        url: `/incidents/employees/${empId}/last-incident`,
      }),
      transformResponse: daysSinceLastIncidentFromApiAdapter,
    }),
    getMillwrightDaysSinceLastFatigueWarning: builder.query<
      MillwrightLastFatigueWarning,
      number
    >({
      query: (empId) => ({
        url: `/incidents/employees/${empId}/last-fatigue-warning`,
      }),
      transformResponse: daysSinceLastFatigueWarningFromApiAdapter,
    }),
  }),
});

export const {
  useGetMillwrightDaysSinceLastIncidentQuery,
  useGetMillwrightDaysSinceLastFatigueWarningQuery,
} = incidentsApi;
